import { MutableRefObject, useEffect, useRef } from 'react';

interface UseClickOutside {
	(
		ref: MutableRefObject<HTMLElement | null>,
		handler: (event: Event) => void,
		params?: { extraDoc?: Document | null }
	): void;
}

export const useClickOutside: UseClickOutside = (ref, handler, params = {}) => {
	const mouseDownTargetRef = useRef<HTMLElement | null>(null);

	useEffect(() => {
		const mouseDownListener = (event: MouseEvent) => {
			mouseDownTargetRef.current = event.target as HTMLElement;
		};

		const clickListener = (event: MouseEvent) => {
			if (
				handler &&
				ref.current &&
				mouseDownTargetRef.current &&
				!ref.current.contains(mouseDownTargetRef.current)
			) {
				handler(event);
			}
		};

		const docs = [document, ...(params.extraDoc ? [params.extraDoc] : [])];

		docs.forEach(doc => {
			doc.addEventListener('mousedown', mouseDownListener);
			doc.addEventListener('click', clickListener);
		});

		return () => {
			docs.forEach(doc => {
				doc.removeEventListener('mousedown', mouseDownListener);
				doc.removeEventListener('click', clickListener);
			});
		};
	}, [ref, handler, params.extraDoc]);

	return null;
};
